(function authExtendModuleDefinition() {

    'use strict';

    angular.module('AuthExtend', ['Auth'])
        .provider('authExtend', [ function () {
            
            this.$get = ['auth','$injector','$q',
                function (auth, $injector,$q) {
                    var restUrlBuilder = $injector.get('restUrlBuilder')('auth');
                    var serviceObject = Object.create(auth);

                    auth.getApplicationId = function () {
                        return this.getData('applicationId');
                    };

                    auth.getUserId = function () {
                            return this.getData('userId');
                    };

                    auth.getOrganizationId = function() {
                        return this.getData('organizationId');
                    };

                    auth.getOrganizationName = function() {
                        return this.getData('appOrganizationName');
                    };

                    auth.getUserOrganizationId = function() {
                        return this.getData('userOrganizationId');
                    };

                    auth.getCreationOuId = function () {
                        return this.getData('creationOuId');
                    };

                    auth.getTheme = function() {
                        return this.getData('theme');
                    };

                    auth.getUrlIcon = function () {
                        return this.getData('urlIcon');
                    };

                    auth.getUrlStartImage = function () {
                        return this.getData('urlStartImage');
                    };

                    auth.getUserHasCertificate = function () {
                        return this.getData('usersHasCertificate');
                    };

                    auth.getMustChangePassword = function() {

                        var result = this.getData('mustChangePassword');
                        if (!result) {
                            return false;
                        }

                        if (result.toLowerCase() === 'false') {
                            return false;
                        }

                        return true;
                    };

                    auth.getHasPendingNotifications = function () {

                        var result = this.getData('hasPendingNotifications');
                        if (!result) {
                            return false;
                        }

                        if (result.toLowerCase() === 'false') {
                            return false;
                        }

                        return true;
                    };

                    auth.changePassword = function (passwordModel) {

                        if (passwordModel == null
                            || passwordModel.oldPassword == null
                            || passwordModel.newPassword == null
                            || passwordModel.confirmPassword == null) {
                            return $q.reject();
                        }

                        var deferred = $q.defer();
                        var data = JSON.stringify(passwordModel);

                        restUrlBuilder.all('Account')
                                      .custom('ChangePassword')
                                      .post(data)
                                      .then(function() {
                                              deferred.resolve();
                                          },
                                          function(error) {
                                              deferred.reject(error);
                                          });
                        return deferred.promise;
                    };

                    auth.getUsers = function () {

                        var result = this.getData('usersOu');
                        return angular.fromJson(result);
                    };
                    
                    return serviceObject;
            }];
            
        }]);
})();